import React, { useContext } from 'react';
import { ModBoss } from '@vp/mod-father';
import PropTypes from 'prop-types';
import OrderHistoryContext from '../../components/contexts/OrderHistoryContext';
import { PageModsContext } from '../../components/contexts/PageModsContext';
import { modfatherTracker as hostTracker } from '../../apis/trackingApi';
import {
  commonVpDependenciesV1,
  orderInfoV1,
  orderInfoV2,
  lineItemGroupInfoV1,
  orderItemGroupItemsInfoV1,
} from '../uxModsContracts';

/**
 * This component handles injection of mods on the item group level.
 * Such mods can either be from site configuration, with a 'itemGroup' scope,
 * or be attached to an order's `itemGroups` objects (within an item group's customOrderData.ux).
 *
 * @param {*} children
 * @param {*} groupId - the id of the group within the specific order to wrap with a ModBoss and mods
 * @param {*} order - the specific order (from a list of orders) that contains an item group requiring mods
 */
const HistoryItemGroupUxModWrapper = ({ groupId, order, children }) => {
  const orderHistoryContext = useContext(OrderHistoryContext);
  const { activeItemGroupLevelPageUxMods: itemGroupUxMods } =
    useContext(PageModsContext);
  const { vistacartTenantName } = orderHistoryContext;

  const orderItemGroups = order?.itemGroups || [];
  const itemGroupData = orderItemGroups.find(
    group => group.groupId === groupId
  );

  const itemGroupAttachedMods = itemGroupData?.customOrderData?.ux || [];

  const environmentData = {
    orderInfoV1: orderInfoV1(order, vistacartTenantName),
    orderInfoV2: orderInfoV2(order, vistacartTenantName),
    lineItemGroupInfoV1: lineItemGroupInfoV1(order, groupId),
    orderItemGroupItemsInfoV1: orderItemGroupItemsInfoV1(order, groupId),
    commonVpDependenciesV1,
  };

  return (
    <ModBoss
      mods={[...(itemGroupUxMods || []), ...(itemGroupAttachedMods || [])]}
      environmentData={environmentData}
      contextKey={groupId}
      hostTracker={hostTracker}
    >
      {children}
    </ModBoss>
  );
};

HistoryItemGroupUxModWrapper.propTypes = {
  groupId: PropTypes.string.isRequired,
  order: PropTypes.object.isRequired,
  children: PropTypes.any,
};

export default HistoryItemGroupUxModWrapper;
